'use strict';

angular.module('mediacloudApp')
    .factory('BaseFileService', function ($resource) {
        return {
            AddBaseFile: $resource('api/basefile'),
            UpdateBaseFile : $resource('api/basefile', {}, {
                update: {
                    method: 'PUT'
                }
            }),
            CancelBaseFile: $resource('api/basefile/:id', {id: '@id'}, {
                erase: {
                    method: 'DELETE', params: {}, isArray: false
                }
            }),
            GetBaseFile: $resource('api/basefile/:id',{id: '@id'}),
            GetMCBaseFile: $resource('api/mcbasefile/:id',{id: '@id'}),
            Thumbnail: $resource('api/basefile/:id/thumbnail',{id: '@id'}),
            AddMetadata: $resource('api/basefile/:id/metadata',{id: '@id'}),
            GetUploadToken: $resource('api/upload/token'),
            SendForCaptioning: $resource('api/basefile/:id/caption/:send',{id: '@id', send: '@send'}),
            NotifyUser: $resource('api/basefile/:id/notification/:notify',{id: '@id', notify: '@notify'}),
            Publish: $resource('api/publish/basefile'),
            Destination: $resource('api/destination/basefile'),
            MoveAsset: $resource('api/asset/move'),
            CopyItem: $resource('api/item/copy'),
            MoveItem: $resource('api/item/move'),
            DeleteItem: $resource('api/item/delete'),
            UpdateItem: $resource('api/item/update'),
            UpdateAssociatedContent: $resource('api/associatedcontent/update'),
            GetAssetId: $resource('api/basefile/asset/:id', {id: '@id'})
        };
    });
